'use client';

import { useEffect } from 'react';
import { Box } from '@wishket/design-system';

import { HeadLineListSkeleton } from '../HeadLineList';

import { useAuthorSearchQuery } from '@/entities/author';
import { useSearchResult } from '@/shared/providers/SearchProvider';
import { SearchedAuthors, SearchSectionTitle } from '@/features/Search';

interface SearchedAuthorListProps {
  searchQuery: string;
}

const SearchedAuthorList = ({ searchQuery }: SearchedAuthorListProps) => {
  const { data, isLoading } = useAuthorSearchQuery({ query: searchQuery });
  const { setIsAuthorEmpty } = useSearchResult();

  useEffect(() => {
    setIsAuthorEmpty(data?.authors.length === 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  if (!data) return <SearchedAuthorSkeleton />;

  if (data?.authors.length === 0) return null;

  return (
    <>
      <Box className="px-5 grid-in-title desktop:px-0">
        <SearchSectionTitle title="작가" count={data.count} />
      </Box>
      <SearchedAuthors authors={data.authors} />
    </>
  );
};

const SearchedAuthorSkeleton = () => {
  return (
    <Box className="px-0 grid-in-content desktop:px-5">
      <HeadLineListSkeleton />
    </Box>
  );
};

export default SearchedAuthorList;
